import { render, staticRenderFns } from "./WordpressContentPage.vue?vue&type=template&id=32e4284c&"
import script from "./WordpressContentPage.vue?vue&type=script&lang=js&"
export * from "./WordpressContentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports